<template>
  <div class="contact-us-banner">
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="container mt-4"
      :breadcrumb="getBreadcrumb"
    />
    <div class="contact-us-banner__container">
      <div>
        <img
          data-src="@images/public/terms/terms-dots.svg"
          width="213"
          height="205 "
          class="lazyload hidden lg:block absolute right-0"
          alt="contact-us-banner"
        >
        <p class="contact-us-banner__title">
          Happy to help. Any time & always
        </p>
        <p class="contact-us-banner__subtitle">
          Connecting with us is easy.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'

export default {
  name: 'ContactUsBanner',
  components: { BaseBreadcrumb },
  computed: {
    ...mapGetters('global', ['getBreadcrumb'])
  }
}
</script>

<style scoped lang="scss">
.contact-us-banner {
  @apply bg-primary-50 w-full h-[283px] lg:h-[250px] rounded-br-[40px] mt-[-15px] pt-4;
  &__container {
    @apply container flex flex-col lg:flex-row justify-between  relative;
  }
  &__title {
    @apply text-primary-700 text__headline-3-xs--bold lg:text__headline-3-md--bold mt-4 lg:mt-9  text-center lg:text-left;
  }
  &__subtitle {
    @apply text-primary-700 text__headline-4-xs--semibold lg:text__headline-4-md--semibold mt-4 text-center lg:text-left;
  }
}
</style>
